module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAMAAABEpIrGAAAAA3NCSVQICAjb4U/gAAAACXBIWXMAAADdAAAA3QFwU6IHAAAAGXRFWHRTb2Z0d2FyZQB3d3cuaW5rc2NhcGUub3Jnm+48GgAAAD9QTFRF////Rkai/0ZdQ0eb/0tUQUec/0xUQUeb/0tVkpXDkpTC/mRtQUib/0tVQUeb/0tVQUeb/0tVQUeb9fX1/0tVqL25+wAAABJ0Uk5TAAsLPT12drCwxcbG3d3l5f39RLszUgAAAGxJREFUOI3tk8kOgCAMRAeVxQXQ2v//VgkuiUZpvPOufW16mAEApW0gon69GJk5OtMg006UGe5Cwnd5PtOXwEsy1LH/KrBvoM/584cdA0ulC+wQykIElQWuQhX+CWLkxNCKsReLI1ZPLq9Q/w0VK0Xj1V9fMAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/flags/fr.png
// module id = 2185
// module chunks = 0